module.exports = __webpack_public_path__ + "img/tp1.88654bf8.jpg";